import React, { createElement, useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { Router } from 'react-router-dom'
import { connect } from 'react-redux'

import AppRouter from './routes'
import Header from '@pages/common/partials/header'
import Footer from '@pages/common/partials/footer'
import { extractKeys } from '@helpers/objects'
import AppGlobals from '@modules/setup-globals'
import Loader from '@shared/loader'
import SidePane from '@pages/common/partials/sidebar'

import { SearchResultsContainer } from '@modules/site-search'
import VehicleInspection from '@agencies/rtd/vehicle-inspection'
// import ApprovedInspections from '@agencies/rtd/approved-inspections'
import PendingSecurityLicences from '@agencies/national_security/pending-approvals'
import UpSkillBatchApprovals from '@agencies/moe/misc_modules/upskill-bahamas-batch'
// import { RoleManagement } from '@modules/officer-management/role-management'
// import PendingRegistries from '@agencies/mysc/culture/pending-approvals'
import MotaDirectorView from '@agencies/mota/director/index'
import FarmerInspections from '@agencies/moa/farm-inspection'
import CourierScanner from '@modules/delivery/courier'
import CollectionsCentre from '@modules/ccc'

import { isSubset } from '@helpers/arrays'

import {
  getAgencies,
  getAgencyServices,
  getAgencyAlerts,
} from '@actions/agencies'
import ENV from '@constants/env'

// const LAST_CONFIG_STORE_KEY = 'LAST_MAINTENENCE_MESSAGE'

export const Main = ({ history, ...props }) => {
  const [ready, setReady] = useState(false)
  const [toggled, setToggled] = useState(false)
  const [maintenance, setMaintenance] = useState(false)
  // const [slideNum, setSlideNum] = useState(1)

  const page = document.documentElement
  const { current_user, roles, token } = $app ?? {}
  const numAgencies = props.agencies?.length
  const numServices = props.services?.length

  let component = null
  let skipAR = false
  let blank = false
  let guard = true

  // Government Survey Popup
  // useEffect(() => {
  //   const getConfig = async () => {
  //     const surveyLinkUsers = "https://a2fsurveys.eastus.cloudapp.azure.com/govcompeti/WebInterview/3FT62C4V/Start"
  //     const surveyLinkBusiness = "https://a2fsurveys.eastus.cloudapp.azure.com/govcompeti/WebInterview/RUN5BASE/Start"
  //     const survey_message = `
  //       <div style="text-align: center; margin-bottom: 8px;">Take the <b>Digital Transformation to Strengthen Competitiveness Annual Survey</b> Today!</div>

  //       <div style="text-align: center; margin-bottom: 8px;">The <b>Digital Transformation to Strengthen Competitiveness Annual Survey</b> invites you to share your experience with government services delivered 
  //       online and in-person. You have been selected to participate in the survey as your feedback is valuable to us. Your insights will help 
  //       us to better understand what is working well and where improvements are needed.</div>

  //       <div style="text-align: center; margin-bottom: 10px;">The effectiveness of this survey hinges significantly on the participation of a diverse and representative sample of <b>Bahamian individuals 
  //       and businesses</b>. The results of this survey will directly inform future government policies and efforts to create faster, more efficient, 
  //       and more user-friendly services for all residents.</div>

  //       <div style="font-size: 15; text-align: center; margin-bottom: 10px;">Survey participation requires only ~10 minutes. </br>Participation is voluntary and all responses are confidential.</div>

  //       <div style="text-align: center; margin-bottom: 10px;">
  //         <b>Click a button below to start the Survey</b>
  //       </div>

  //       <div style="display: flex; flex-direction: column; align-items: center; margin-bottom: 10px;">
  //         <button class="btn btn-secondary" style="background-color: #835eb5!important; border-color: #835eb5!important; margin-bottom: 10px;" onclick="window.open('${surveyLinkUsers}', '_blank')">
  //           Government Service Users Survey
  //         </button>

  //         <button class="btn btn-secondary" style="background-color: rgb(227 81 157)!important; border-color: rgb(227 81 157)!important;" onclick="window.open('${surveyLinkBusiness}', '_blank')">
  //           Business Population Survey
  //         </button>
  //       </div>

  //       <div style="text-align: center; margin-bottom: 10px;">
  //         <b>Thank you for helping to strengthen public service delivery.</b>
  //       </div>

  //       <div style="font-size: 13; font-style: italic; text-align: left; margin-bottom: 6px;">
  //         No identifying personal data will be published. Data is protected in accordance with applicable privacy standards.
  //       </div>

  //       <div style="font-size: 13; font-style: italic; text-align: left;">
  //         This survey is being conducted by the Digital Transformation Unit of the Department of Information and Communications Technology as a part 
  //         of its ongoing efforts to improve public sector service delivery, and administered by A2F Consulting on behalf of the Government of The Bahamas.
  //       </div>
  //     `

  //     if (slideNum == 1) {
  //       let popups = sessionStorage.getItem("homepage_survey");
  //       const { hide_survey } = JSON.parse(popups) || { hide_survey: false };
  //       // If session storage contains hide_survey flag as true then never show popup
  //       if (hide_survey) { setSlideNum(2); return }

  //       await Swal.fire({
  //         icon: 'info',
  //         title: 'You Are Invited to Help Improve Government Services',
  //         html: survey_message,
  //         // confirmButtonText: "Don't Show Me This Message Again",
  //         confirmButtonText: "Done",
  //         confirmButtonColor: '#4cc16a',
  //         showDenyButton: true,
  //         denyButtonText: 'Maybe next time',
  //         denyButtonColor: '#949494',
  //         showCancelButton: true,
  //         cancelButtonText: 'Hide Prompt',
  //         cancelButtonColor: '#ff6666',
  //         allowEnterKey: false,
  //         allowEscapeKey: false,
  //         allowOutsideClick: false,
  //         width: 640,
  //       }).then((result) => {
  //         if (result.isDismissed) {
  //           sessionStorage.setItem("homepage_survey", JSON.stringify({ hide_survey: true }));
  //           setSlideNum(2)
  //         } else if (result.isDenied) {
  //           setSlideNum(2)
  //         } else {
  //           sessionStorage.setItem("homepage_survey", JSON.stringify({ hide_survey: true }));
  //           setSlideNum(2)
  //           // If user clicks "Done" then proceed to next slide/popup
  //         }
  //       });

  //       return
  //     }
  //   }

  //   if (slideNum == 1) getConfig()

  // }, [slideNum])

  useEffect(() => {
    const getConfig = async () => {
      let text = null

      try {
        const { data } = await $app.axios('/api_config')

        const { maintenance_mode, maintenance_message } = data
        // const lastUpdate = window.localStorage.getItem(LAST_CONFIG_STORE_KEY)
        // const thisUpdate = new Date(updated_at).getTime()

        // Display Error Always, regardless of last config update
        if (maintenance_mode && maintenance_message) {
          text = data.maintenance_message
          // Message is set & user did not click "Do Not Show This Again"
          // since last change to config
        } else if (maintenance_message) {
          let popups = sessionStorage.getItem("popups");
          const {hide_maintenance} = JSON.parse(popups) || { hide_maintenance: false };
          // If session storage contains hide_maintenance flag as true then never show popup
          if (hide_maintenance) { return }

          await Swal.fire({
            icon: 'info',
            title: 'Alert',
            html: maintenance_message
              .replaceAll('&lt;', '<')
              .replaceAll('&gt;', '>')
              .replaceAll('&#39;', "'"),
            // confirmButtonText: "Don't Show Me This Message Again",
            confirmButtonText: "Okay",
            showCancelButton: false,
            // cancelButtonText: 'Okay',
            showDenyButton: true,
            denyButtonText: 'Hide Prompt',
          }).then((result) => {
            if (result.isDenied) {
              sessionStorage.setItem("popups", JSON.stringify({ hide_maintenance: true }));
            }
          });

          // if (isConfirmed) {
          //   window.localStorage.setItem(LAST_CONFIG_STORE_KEY, thisUpdate)
          // }

          return
        }
      } catch (err) {
        if (/^5[0-9]{2}/.test(err.response?.status)) {
          text = `
            We are currently unable to reach the server.
            Please try again later; we are sorry for the inconvenience
          `
        }

        console.error(err)
      }

      if (text) {
        Swal.fire({
          icon: 'warning',
          title: 'Temporary Service Interruption/Maintenance',
          text,
          showConfirmButton: false,
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
        })

        setMaintenance(true)
      }
    }

    // if (slideNum == 2) getConfig()
    getConfig()

    if (ENV.SIDENAV_MODE == 'pilot-qa') {
      window.addEventListener('keyup', updateProfile)

      return () => {
        window.removeEventListener('keyup', updateProfile)
      }
    }
  })

  useEffect(() => {
    if (token) {
      props.getAgencyServices()
      props.getAgencies()

      const fn = () => props.getAgencyAlerts()
      const timer = setInterval(fn, 300000) // 5 MINUTES
      fn()

      return () => clearInterval(timer)
    }
  }, [token]) // eslint-disable-line

  useEffect(() => {
    window.$app = new AppGlobals(
      sessionStorage.getItem('user'),
      props.agencies,
      props.services
    )

    $app.ready && setReady(true)
  }, [numAgencies, numServices]) // eslint-disable-line

  const togglePanel = () => {
    setToggled(!toggled)
    page.classList.toggle('nav_open', !toggled)
  }

  useEffect(() => {
    const openSidenav = () => {
      if (window.innerWidth < 992 && !toggled) togglePanel()
    }

    window.addEventListener('open-sidenav', openSidenav)
    return () => window.removeEventListener('open-sidenav', openSidenav)
  }, [toggled]) // eslint-disable-line

  if (maintenance) return null
  if (token && !ready) return <Loader loading={true} />

  if (roles?.includes('collections_centre')) {
    component = CollectionsCentre
    skipAR = true
  } else if (
    roles?.length == 2 &&
    roles.includes('courier') &&
    roles.some(r => /_dispatcher$/.test(r))
  ) {
    component = CourierScanner
  // } else if (isSubset(roles, ['moss'])) {
  //   component = PendingDisabilities
  // } else if (roles?.includes('role_admin')) {
  //   component = RoleManagement
  } else if (isSubset(roles, ['mota', 'director']) || isSubset(roles, ['mota', 'senior_officer', 'trainer'])) {
    component = MotaDirectorView
  // } else if (isSubset(roles, ['culture', 'registry'])) {
  //   component = PendingRegistries
  } else if (isSubset(roles, ['national_security', 'minister'])) {
    component = PendingSecurityLicences
  // } else if (isSubset(roles, ['road_traffic', 'financial_officer'])) {
  //   component = ApprovedInspections
  } else if (isSubset(roles, ['moe', 'upskill_bahamas'])) {
    component = UpSkillBatchApprovals
  } else if (roles?.includes('inspector')) {
    if (roles.includes('road_traffic')) component = VehicleInspection
    if (roles.includes('moa')) component = FarmerInspections
  } else if (/^\/(print)/.test(window.location.pathname)) {
    blank = true
  }

  if (skipAR) {
    return <Router history={history} children={createElement(component)} />
  }

  if (component || blank)
    return (
      <Router history={history}>
        <AppRouter component={component} noAuthGuard={!guard} />
      </Router>
    )

  if (current_user) {
    return (
      <Router history={history}>
        <div className={'wrapper ' + (toggled ? 'sidebar_minimize' : '')}>
          <Header {...{ toggled, togglePanel }} />
          <SearchResultsContainer />
          <SidePane toggled={toggled} togglePanel={togglePanel} hide={blank} />
          <div className='main-panel'>
            <div className='container'>
              <AppRouter />
            </div>
            <Footer />
          </div>
        </div>
      </Router>
    )
  }

  return (
    <Router history={history}>
      <AppRouter />
    </Router>
  )
}

export default connect(
  state => ({
    ...extractKeys(state.users, 'error', 'success_message'),
    ...extractKeys(state.search, 'term'),
    ...extractKeys(state.agencies, 'agencies', 'services'),
  }),
  {
    getAgencies,
    getAgencyAlerts,
    getAgencyServices,
  }
)(Main)

async function updateProfile({ altKey, ctrlKey, key }) {
  const { axios, current_user, roles } = $app
  if (!current_user) return

  if (altKey && ctrlKey && key == 'q') {
    const id = roles.length == 1 && roles[0] == 'pilot' ? '' : current_user.id
    const { data: profile } = await axios.get('/profiles/' + id)

    const data = {
      ...current_user,
      ...extractKeys(
        profile,
        'NIB',
        'roles',
        'island',
        'gender',
        'drivers_license_number',
        'phone_number',
        'additional_phone_number'
      ),
    }

    sessionStorage.setItem('user', JSON.stringify(data))
    window.location.reload()
  }

  if (altKey && ctrlKey && key == 'w') {
    console.log($app.token)
  }
}
